export const M1_UNIT_13 = {
  id: "u13-describing-day",
  title: "Unidad 13: Describing Your Day",
  topic: "Present Simple & Daily Routines",
  iconType: "sun",
  grammarImage: "/u13-present-simple.jpg",
  grammarText: "I/You/We/They eat. He/She/It eats. Usamos el Presente Simple para rutinas diarias.",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: READING - ANA'S MORNING (Contexto: 3rd Person Singular)
    // Enfoque: Comprensión lectora simple.
    // ----------------------------------------------------------------------
    {
      id: "u13-set1",
      title: "Set 1: Ana's Morning",
      questions: [
        {
          type: "mc",
          q: "READING:\n'Ana is a teacher. She gets up at 6:00 AM every day.'\n\nQuestion: What time does Ana get up?",
          options: ["At 6:00 AM", "At 7:00 AM", "At 8:00 AM"],
          a: "At 6:00 AM"
        },
        {
          type: "mc",
          q: "READING:\n'First, she takes a shower. Then, she has breakfast.'\n\nQuestion: What does she do first?",
          options: ["Takes a shower", "Has breakfast", "Goes to work"],
          a: "Takes a shower"
        },
        {
          type: "blank",
          q: "READING:\n'She drinks coffee and eats toast.'\n\nQuestion: She drinks ___.",
          a: "coffee"
        },
        {
          type: "match",
          q: "Match Action to Time",
          pairs: [
            { left: "Get up", right: "6:00 AM" },
            { left: "Breakfast", right: "Coffee & Toast" },
            { left: "Job", right: "Teacher" }
          ],
          a: "completed"
        },
        { type: "input", q: "She ___ (tomar) a shower.", a: "takes" },
        { type: "order", q: "Ordena", words: ["She", "gets", "up", "early."], a: "She gets up early." },
        { type: "mc", q: "Does she drink tea? (Based on the text)", options: ["No", "Yes"], a: "No" },
        { type: "input", q: "Ana ___ (tener) breakfast.", a: "has" },
        { type: "order", q: "Ordena", words: ["She", "eats", "toast."], a: "She eats toast." },
        { type: "match",
          q: "Verb Forms",
          pairs: [
            { left: "I get", right: "She gets" },
            { left: "I take", right: "She takes" },
            { left: "I have", right: "She has" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: READING - TOM'S COMMUTE (Contexto: Transport & Work)
    // Enfoque: Verbos de movimiento (Go, Leave, Arrive).
    // ----------------------------------------------------------------------
    {
      id: "u13-set2",
      title: "Set 2: Tom goes to work",
      questions: [
        {
          type: "mc",
          q: "READING:\n'Tom leaves his house at 8:00 AM. He walks to the bus station.'\n\nQuestion: How does Tom go to the station?",
          options: ["He walks", "He drives", "He runs"],
          a: "He walks"
        },
        {
          type: "mc",
          q: "READING:\n'He catches the bus at 8:15 AM. The bus goes to the city center.'\n\nQuestion: Where does the bus go?",
          options: ["City center", "School", "Park"],
          a: "City center"
        },
        {
          type: "blank",
          q: "READING:\n'He starts work at 9:00 AM. He works in a bank.'\n\nQuestion: Tom works in a ___.",
          a: "bank"
        },
        {
          type: "match",
          q: "Match Verbs",
          pairs: [
            { left: "Leave", right: "Leaves" },
            { left: "Walk", right: "Walks" },
            { left: "Catch", right: "Catches" }
          ],
          a: "completed"
        },
        { type: "input", q: "He ___ (ir) to work by bus.", a: "goes" },
        { type: "order", q: "Ordena", words: ["He", "starts", "work", "at", "nine."], a: "He starts work at nine." },
        { type: "mc", q: "Does he drive to work?", options: ["No", "Yes"], a: "No" },
        { type: "input", q: "Tom ___ (dejar/salir) home at 8.", a: "leaves" },
        { type: "order", q: "Ordena", words: ["The", "bus", "is", "fast."], a: "The bus is fast." },
        { type: "match",
          q: "Sequence",
          pairs: [
            { left: "1. Leaves house", right: "8:00" },
            { left: "2. Catches bus", right: "8:15" },
            { left: "3. Starts work", right: "9:00" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: READING - THE FAMILY DINNER (Contexto: Plural "We/They")
    // Enfoque: Verbos sin "S" (Base form).
    // ----------------------------------------------------------------------
    {
      id: "u13-set3",
      title: "Set 3: Family Evening",
      questions: [
        {
          type: "mc",
          q: "READING:\n'The Smith family has dinner at 7:00 PM. They cook together.'\n\nQuestion: What do they do together?",
          options: ["Cook", "Sleep", "Run"],
          a: "Cook"
        },
        {
          type: "mc",
          q: "READING:\n'After dinner, the parents watch TV and the children play games.'\n\nQuestion: Who watches TV?",
          options: ["The parents", "The children", "The dog"],
          a: "The parents"
        },
        {
          type: "blank",
          q: "READING:\n'They go to bed at 10:00 PM.'\n\nQuestion: They go to ___ at 10.",
          a: "bed"
        },
        {
          type: "match",
          q: "Plural Verbs (No S)",
          pairs: [
            { left: "They", right: "Cook" },
            { left: "We", right: "Play" },
            { left: "Parents", right: "Watch" }
          ],
          a: "completed"
        },
        { type: "input", q: "We ___ (cenar) at seven.", a: "have dinner" },
        { type: "order", q: "Ordena", words: ["They", "watch", "TV", "together."], a: "They watch TV together." },
        { type: "mc", q: "The children play games. (Correct?)", options: ["Yes", "No"], a: "Yes" },
        { type: "input", q: "They ___ (ir) to bed late.", a: "go" },
        { type: "order", q: "Ordena", words: ["We", "cook", "dinner."], a: "We cook dinner." },
        { type: "match",
          q: "Match Activity",
          pairs: [
            { left: "7:00 PM", right: "Dinner" },
            { left: "After dinner", right: "TV & Games" },
            { left: "10:00 PM", right: "Bed" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: GRAMMAR - HE/SHE/IT RULE (Focus)
    // Enfoque: Regla de la "S" y "ES".
    // ----------------------------------------------------------------------
    {
      id: "u13-set4",
      title: "Set 4: The 'S' Rule",
      questions: [
        {
          type: "match",
          q: "Add S or ES?",
          pairs: [
            { left: "Watch", right: "Watches" },
            { left: "Go", right: "Goes" },
            { left: "Play", right: "Plays" }
          ],
          a: "completed"
        },
        { type: "mc", q: "She ___ (wash) her face.", options: ["washes", "washs", "wash"], a: "washes" },
        { type: "mc", q: "He ___ (fix) the car.", options: ["fixes", "fixs", "fix"], a: "fixes" },
        { type: "input", q: "It ___ (ir) very fast.", a: "goes" },
        { type: "input", q: "My dad ___ (ver) TV.", a: "watches" },
        { type: "order", q: "Ordena", words: ["She", "brushes", "her", "teeth."], a: "She brushes her teeth." },
        { type: "mc", q: "The dog ___ (catch) the ball.", options: ["catches", "catchs"], a: "catches" },
        { type: "match",
          q: "Base -> 3rd Person",
          pairs: [
            { left: "Finish", right: "Finishes" },
            { left: "Kiss", right: "Kisses" },
            { left: "Teach", right: "Teaches" }
          ],
          a: "completed"
        },
        { type: "input", q: "He ___ (hacer) his homework.", a: "does" },
        { type: "order", q: "Ordena", words: ["He", "goes", "to", "school."], a: "He goes to school." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: GRAMMAR - HAVE vs HAS (Irregular)
    // Enfoque: Verbo tener/haber en rutinas.
    // ----------------------------------------------------------------------
    {
      id: "u13-set5",
      title: "Set 5: Have vs Has",
      questions: [
        {
          type: "match",
          q: "Choose Correct Form",
          pairs: [
            { left: "I", right: "Have" },
            { left: "She", right: "Has" },
            { left: "They", right: "Have" }
          ],
          a: "completed"
        },
        { type: "mc", q: "He ___ breakfast at 8.", options: ["has", "have", "haves"], a: "has" },
        { type: "mc", q: "We ___ lunch at 1.", options: ["have", "has"], a: "have" },
        { type: "input", q: "My sister ___ a new car.", a: "has" },
        { type: "input", q: "You ___ a nice house.", a: "have" },
        { type: "order", q: "Ordena", words: ["She", "has", "dinner", "late."], a: "She has dinner late." },
        { type: "match",
          q: "Meal Times",
          pairs: [
            { left: "Morning", right: "Have breakfast" },
            { left: "Noon", right: "Have lunch" },
            { left: "Evening", right: "Have dinner" }
          ],
          a: "completed"
        },
        { type: "mc", q: "The cat ___ some milk.", options: ["has", "have"], a: "has" },
        { type: "input", q: "I ___ a shower every day.", a: "have" },
        { type: "order", q: "Ordena", words: ["We", "have", "coffee", "together."], a: "We have coffee together." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: I/YOU/WE/THEY (Base Form Practice)
    // Enfoque: No agregar "S".
    // ----------------------------------------------------------------------
    {
      id: "u13-set6",
      title: "Set 6: Plural Routines",
      questions: [
        {
          type: "match",
          q: "Sentence Builder",
          pairs: [
            { left: "I", right: "Wake up" },
            { left: "We", right: "Go home" },
            { left: "They", right: "Watch TV" }
          ],
          a: "completed"
        },
        { type: "mc", q: "You ___ English very well.", options: ["speak", "speaks", "speaking"], a: "speak" },
        { type: "mc", q: "My parents ___ in a big house.", options: ["live", "lives"], a: "live" },
        { type: "input", q: "I ___ (trabajar) in an office.", a: "work" },
        { type: "input", q: "We ___ (jugar) soccer on Sundays.", a: "play" },
        { type: "order", q: "Ordena", words: ["They", "cook", "dinner", "every", "night."], a: "They cook dinner every night." },
        { type: "match",
          q: "Subject - Verb",
          pairs: [
            { left: "Dogs", right: "Run" },
            { left: "Cats", right: "Sleep" },
            { left: "Birds", right: "Fly" }
          ],
          a: "completed"
        },
        { type: "mc", q: "You and I ___ friends.", options: ["are", "is", "am"], a: "are" },
        { type: "input", q: "We ___ (leer) books.", a: "read" },
        { type: "order", q: "Ordena", words: ["I", "love", "my", "job."], a: "I love my job." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: TRANSLATION (Ordering - Spanish to English)
    // Enfoque: Estructura de la frase.
    // ----------------------------------------------------------------------
    {
      id: "u13-set7",
      title: "Set 7: Translation Builder",
      questions: [
        { type: "order", q: "Ella se levanta a las 7.", words: ["She", "gets", "up", "at", "7."], a: "She gets up at 7." },
        { type: "order", q: "Yo voy al trabajo.", words: ["I", "go", "to", "work."], a: "I go to work." },
        { type: "order", q: "Nosotros comemos pizza.", words: ["We", "eat", "pizza."], a: "We eat pizza." },
        { type: "order", q: "Él ve la televisión.", words: ["He", "watches", "TV."], a: "He watches TV." },
        { type: "order", q: "Ellos viven en Madrid.", words: ["They", "live", "in", "Madrid."], a: "They live in Madrid." },
        { type: "order", q: "Tú bebes agua.", words: ["You", "drink", "water."], a: "You drink water." },
        { type: "order", q: "El autobús llega tarde.", words: ["The", "bus", "arrives", "late."], a: "The bus arrives late." },
        { type: "order", q: "Mi madre cocina bien.", words: ["My", "mother", "cooks", "well."], a: "My mother cooks well." },
        { type: "order", q: "Me gusta el café.", words: ["I", "like", "coffee."], a: "I like coffee." },
        { type: "order", q: "Ella tiene un perro.", words: ["She", "has", "a", "dog."], a: "She has a dog." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: MIXED PRACTICE (Review)
    // Enfoque: Mezcla rápida de singular/plural.
    // ----------------------------------------------------------------------
    {
      id: "u13-set8",
      title: "Set 8: Rapid Fire",
      questions: [
        { type: "mc", q: "Tom ___.", options: ["plays", "play"], a: "plays" },
        { type: "mc", q: "Tom and Jerry ___.", options: ["play", "plays"], a: "play" },
        { type: "input", q: "My sister ___ (estudiar) medicine.", a: "studies" },
        { type: "input", q: "My brothers ___ (estudiar) art.", a: "study" },
        { type: "match",
          q: "Correct verb",
          pairs: [
            { left: "The sun", right: "Shines" },
            { left: "The stars", right: "Shine" },
            { left: "It", right: "Rains" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["The", "earth", "goes", "around", "the", "sun."], a: "The earth goes around the sun." },
        { type: "mc", q: "Everyone ___ happy.", options: ["is", "are"], a: "is" },
        { type: "input", q: "Nobody ___ (saber).", a: "knows" },
        { type: "order", q: "Ordena", words: ["Time", "flies."], a: "Time flies." },
        { type: "mc", q: "He ___ English.", options: ["teaches", "teach"], a: "teaches" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: PRE-CONVERSATION (Questions)
    // Enfoque: Preparación para el diálogo.
    // ----------------------------------------------------------------------
    {
      id: "u13-set9",
      title: "Set 9: Interview Prep",
      questions: [
        { type: "match",
          q: "Match Question to Answer",
          pairs: [
            { left: "Do you work?", right: "Yes, I do." },
            { left: "Does she cook?", right: "No, she doesn't." },
            { left: "When do you start?", right: "At 9:00." }
          ],
          a: "completed"
        },
        { type: "mc", q: "___ you live here?", options: ["Do", "Does", "Are"], a: "Do" },
        { type: "mc", q: "___ she like chocolate?", options: ["Does", "Do", "Is"], a: "Does" },
        { type: "input", q: "What time ___ (hacer) you get up?", a: "do" },
        { type: "input", q: "Where ___ (hacer) he work?", a: "does" },
        { type: "order", q: "Ordena", words: ["Do", "you", "speak", "English?"], a: "Do you speak English?" },
        { type: "mc", q: "___ your friend play tennis?", options: ["Does", "Do"], a: "Does" },
        { type: "input", q: "Why ___ (hacer) they cry?", a: "do" },
        { type: "order", q: "Ordena", words: ["Does", "it", "rain", "here?"], a: "Does it rain here?" },
        { type: "match",
          q: "Auxiliary Verb",
          pairs: [
            { left: "I/You/We/They", right: "Do" },
            { left: "He/She/It", right: "Does" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: CONVERSATION MASTERY (The Interview)
    // Enfoque: Completar un diálogo lógico.
    // ----------------------------------------------------------------------
    {
      id: "u13-set10",
      title: "Set 10: The Interview",
      questions: [
        {
          type: "mc",
          q: "A: Hello! Tell me about your day. What time ___ you get up?",
          options: ["do", "does", "are"],
          a: "do"
        },
        {
          type: "blank",
          q: "B: I ___ up at 7:00 AM.",
          a: "get"
        },
        {
          type: "mc",
          q: "A: And what do you ___ after that?",
          options: ["do", "does", "make"],
          a: "do"
        },
        {
          type: "order",
          q: "B: (Ordena la respuesta)",
          words: ["I", "have", "breakfast", "with", "my", "family."],
          a: "I have breakfast with my family."
        },
        {
          type: "blank",
          q: "A: Nice. ___ your wife work?",
          a: "Does"
        },
        {
          type: "mc",
          q: "B: Yes, she ___. She works in a hospital.",
          options: ["does", "do", "is"],
          a: "does"
        },
        {
          type: "input",
          q: "A: When ___ (hacer) she finish work?",
          a: "does"
        },
        {
          type: "order",
          q: "B: (Ordena la respuesta)",
          words: ["She", "finishes", "at", "5:00", "PM."],
          a: "She finishes at 5:00 PM."
        },
        {
          type: "match",
          q: "Review the Interview",
          pairs: [
            { left: "The man", right: "Gets up at 7" },
            { left: "The wife", right: "Works in hospital" },
            { left: "They", right: "Have breakfast together" }
          ],
          a: "completed"
        },
        {
          type: "order",
          q: "Final Phrase",
          words: ["Have", "a", "nice", "day!"],
          a: "Have a nice day!"
        }
      ]
    }
  ]
};